var render, staticRenderFns
import script from "./Status.vue?vue&type=script&lang=jsx"
export * from "./Status.vue?vue&type=script&lang=jsx"
import style0 from "./Status.vue?vue&type=style&index=0&id=2c2ee1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ee1de",
  null
  
)

export default component.exports